module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s2-960abfa89b1e38a0a116e392d575423b.jpg";